import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import RefreshIcon from '../../icons/refresh.svg';

const RefreshButton = ({ loading, onClick }) => (
  loading ?
    <div style={{ display: 'flex', justifyContent: 'center', height: 48, width: 48, alignItems: 'center' }}>
      <CircularProgress color="primary" classes={{ colorPrimary: 'color-white' }} size={24} thickness={5} />
    </div> :
    <IconButton
      color="inherit"
      onClick={onClick}
    >
      <SvgIcon>
        <RefreshIcon />
      </SvgIcon>
    </IconButton>
);

export default RefreshButton;
